module.exports = "./img/aaedc07c64c0af568be5e18fe38b59a1.jpg";